import FavoritesResolver from 'resolvers/RTMResolvers/FavoritesResolver';

/**
 * Builds a service to access favorites, and hold all of their business
 * logic.
 */
export default (() => {
  /**
   * @type {FavoritesResolver}
   */
  let favoritesResolver;
  let isRegistered = false;

  /**
   * Add course/lesson to user favourites
   * @param {string} accountId
   * @param {string} activityId
   * @param {string} type
   * @param {string} projectId
   * @param {string} workspaceId
   * @returns {object} 
   */
  const addFavourites = async (accountId, activityId, type, projectId, workspaceId) => {
    const response = await favoritesResolver.createFavourite(accountId, activityId, type, projectId, workspaceId);
    return response;
  };

  /**
   * remove course/lesson from user favourites
   * @param {string} accountId
   * @param {string} favoriteId
   * @param {string} rootElementId
   * @returns {object} 
   */
  const removeFavorites = async (accountId, favoriteId, rootElementId) => {
    const response = await favoritesResolver.removeFavorite(accountId, favoriteId, rootElementId);
    return response;
  };

  /**
   * Fetch user favourites
   * @param {string} accountId
   * @returns {object} 
   */
  const getFavouriteActivityList = async (accountId) => {
    const response = await favoritesResolver.getFavourites(accountId);
    return response;
  };

  return {
    isRegistered: () => isRegistered,

    register: (connectionProvider) => {
      isRegistered = true;
      favoritesResolver = new FavoritesResolver(connectionProvider);
    },
    addFavourites,
    getFavouriteActivityList,
    removeFavorites,
  };
})();
